import { useState } from 'react';
import {
    Button,
    Col,
    Row
} from 'reactstrap';

import ShareModal from './ShareModal';

const TripHeader = ({ title, seats, duration, places_covered }) => {
    const [modal, setModal] = useState(false);

    const toggle = () => setModal(!modal);

    return (
        <section>
            {/* {private_plan && <AlertBoxClosable icon="person" text={private_plan} />} */}
            <section className="container pt-5 pb-4 px-sm-4">
                <Row>
                    <Col md="10" lg="10">
                        <h2 className="mb-3">{title}</h2>
                    </Col>
                    <Col className="d-none d-md-block text-end" md="2" lg="2">
                        <Button className="hover-white" outline onClick={toggle}><i className="bi bi-share-fill pe-1"></i> Share</Button>
                    </Col>
                </Row>
                <div className="d-flex gap-4">
                    <p><i className="bi bi-person pe-1 text-primary"></i> {seats} Seats</p>
                    <p><i className="bi bi-clock pe-1 text-primary"></i> {duration}</p>
                    {/* TODO - These will be used once we define schema for treks */}
                    {/*age && <p><i className="bi bi-person-check pe-1 text-primary"></i> Age {age}</p>}
                    {location && <p><i className="bi bi-star-fill pe-1 text-primary"></i>Difficulty - {grade}</p>}
                    {grade && <p><i className="bi bi-geo-alt pe-1 text-primary"></i> {location}</p>} */}
                </div>
                <small className="text-muted">Places Covered - {places_covered.join("| ")}</small>
            </section>
            <ShareModal modal={modal} toggle={toggle} body="sharelink" />
        </section>
    );
};

export default TripHeader;